/**
 * `unreadAdvisorIds` is a bag of unread *messages*: the same assistantId is
 * pushed once per inbound reply. Do not unique the array for badges — that
 * would count advisors, not messages.
 */
export function unreadMessageCount(ids: string[]): number {
  return ids.length
}

export function unreadMessageCountByAdvisor(ids: string[]): Record<string, number> {
  return ids.reduce<Record<string, number>>((acc, id) => {
    acc[id] = (acc[id] ?? 0) + 1
    return acc
  }, {})
}
